export default __webpack_public_path__ + "static/media/learner-login.578246d0.jpeg";